import * as React from 'react';

import { connect } from 'react-redux';

import AppState from '@webapp/store/state';

import ErrorMessage from '@components/basics/error-message/index';

interface ErrorCtrlProps {
  className?: string;
  type: string;
  errors?: { [key: string]: string | undefined };
  hasBackground?: boolean;
  message?: React.ReactNode;
}

const mapStateToProps = (state: AppState) => ({
  errors: state.ui.errors,
});

export const ErrorCtrl: React.FC<ErrorCtrlProps> = (props) =>
  props.errors && props.errors[props.type] ? (
    <ErrorMessage
      className={props.className}
      hasBackground={props.hasBackground}
      errorId={props.errors[props.type]}
      message={props.message}
    />
  ) : null;

export default connect(mapStateToProps, null)(ErrorCtrl);
